import { is2xxStatus } from './AlertMessageLogic'

export default function messageOnCreateCredential(status) {
    let message

    if (is2xxStatus(status)) status = '2xx'

    switch (status) {
        case 503:
            message = 'Ops! Ocorreu um problema com a internet e não conseguimos gerar a credencial.'
            break
        case '2xx':
            message = 'Geramos a credencial.'
            break
        case 401:
            message =
                'Ops! O seu tempo de acesso expirou, para continuar utilizando o sistema é necessário realizar o login.'
            break
        default:
            message = 'Ops! Algo de estranho ocorreu e não geramos a credencial. Por favor, tente novamente mais tarde.'
    }
    return message
}
